







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import VuePlotly from '@statnett/vue-plotly';

import { mixins } from 'vue-class-component';
import QueryEndpointData from './dataquery-mixin';


@Component({
    components: {
        VuePlotly
    }
})
export default class Metrics extends mixins(QueryEndpointData) {
    @Prop() histogram!: boolean;
    @Prop() selectedMetric!: string;
    @Prop() metricKey!: string;
    @Prop() metric_type?: 'supply_chain_leg_cat' | 'total' | 'hist_supply_chain' | 'hist_total' | null;

    get metricsHistogramUrl() {
        return process.env.VUE_APP_BACKEND_BASE + "/supplychainexplorer/metricshistogram";
    }

    mounted() {
        this.loadData(this.metricsHistogramUrl);
    }

    @Watch('updateRequired')
    reloadData(newVal: any, oldVal: any) {
        this.loadData(this.metricsHistogramUrl);
    }

    get plotData() {
        if (!this.metricKey || !this.data || this.data.length === 0) {
            return [];
        }

        var trace = this.data.find(
            (item: any) => item.name === this.metricKey
        );

        var linnearX = trace.x.map((v: number) => Math.pow(10, v));

        var metricUnits: { [key: string]: { prefix?: string; suffix?: string } } = {
            'cost_per_tonne': { prefix: '$' },
            'od_km': { suffix: ' km' },
            'od_hour': { suffix: ' h' },
            'co2_per_tonne': { suffix: ' tn' },
        };

        var unit = metricUnits[this.metricKey] || {};
        var prefix = unit.prefix || '';
        var suffix = unit.suffix || '';

        // Update trace
        var updatedTrace = {
            ...trace,
            type: "bar",
            marker: { color: "#42A5F5" },
            opacity: 0.6,
            customdata: linnearX,
            hovertemplate:
                `Sum of Tonnes: %{y:,.0f} tn<br>` +
                `${this.selectedMetric}: ${prefix}%{customdata:,.2f}${suffix}<br>` +
                `log<sub>10</sub>(${this.selectedMetric}): %{x:.2f}<extra></extra>`,
        };

        return trace ? [updatedTrace] : [];
    }

    get plotLayout() {

        var trace = this.data.find(
            (item: any) => item.name === this.metricKey
        );
        var binCenters = trace?.x || [];

        // Limit number of ticks to 8
        var maxTicks = 8;
        var step = Math.ceil(binCenters.length / maxTicks);

        // Generate linnear values for x axis (this is to make it easier to read the data, the actual data values are still log10)
        var tickvals = binCenters.filter((_: any, i: any) => i % step === 0);
        var ticktext = tickvals.map((v: any) => {
            var val = 10 ** v;
            return val < 1 ? val.toFixed(1) : Number(val.toFixed(0)).toLocaleString();
        });

        return {
            title: {
                text: this.selectedMetric,
                font: { size: 18 },
                family: 'Roboto',
                x: 0.5,
                xanchor: 'center',
            },
            margin: { t: 40, b: 40 },
            xaxis: {
                type: 'linear',
                title: `log<sub>10</sub>(${this.selectedMetric})`,
                tickvals,
                ticktext
            },
            bargap: 0.05,
            yaxis: { title: 'Sum of Tonnes' },
            hoverlabel: {
                font: {
                    color: '#FFFFFF',
                },

            }
        };
    }

    closeHistogram() {
        this.$emit('close');
    }

    get internalDialog(): boolean {
        return this.histogram && this.metric_type === 'hist_total';
    }

}


